import { NgModule } from '@angular/core';
import { ListViewRoutingModule } from './list-view-routing.module';

@NgModule({

    imports: [
        ListViewRoutingModule
    ]
})
export class ListViewModule { }

